import React from "react";
import { useNavigate } from "react-router-dom";
import "./DataSources.css";
import { ArrowLeft } from "lucide-react";
import optibotLogoNoText from "../girl-assistant3.png";
import TopRightAuth from "../components/TopRightAuth";
import { isEmbedPath } from "../context/EmbedContext";

const DATA_SOURCES = [
    {
        category: "Core Accessibility Standards",
        items: [
            { name: "ISO 14289-1 (PDF/UA-1)", note: "PDF/UA compliance foundation" },
            { name: "ISO 32000-2 (PDF 2.0)", note: "PDF structural & accessibility implications" },
            { name: "Accessible Rich Internet Applications (WAI-ARIA) 1.2", note: "ARIA roles, states, properties" },
            { name: "HTML Standard Foundation.txt", note: "HTML semantics baseline" },
            { name: "Clause Mapping.pdf", note: "Internal crosswalk support" }
        ]
    },
    {
        category: "Regulatory – EU",
        items: [
            { name: "EN 301 549 v3.2.1 (en_301549v030201p)", note: "EU accessibility compliance standard" }
        ]
    },
    {
        category: "Regulatory – US",
        items: [
            { name: "U.S. Access Board ICT / Section 508", note: "Federal accessibility requirement" }
        ]
    },
    {
        category: "PDF & Remediation Tools",
        items: [
            { name: "Aspose PDF – UA Compliance.pdf", note: "PDF remediation guidance" }
        ]
    },
    {
        category: "Assistive Technology Documentation",
        items: [
            { name: "NVDA 2025.3.3 User Guide", note: "Real-world screen reader behavior" }
        ]
    },
    {
        category: "SEO / AEO / GEO Research",
        items: [
            { name: "search-engine-optimization-st.txt", note: "SEO structural alignment" },
            { name: "research-based-web-design-*.txt (HHS)", note: "Usability & accessibility research" },
            { name: "Voice search optimization in digital media.txt", note: "Voice/AEO support" },
            { name: "GEO Generative Engine Optimization.txt", note: "AI-answer optimization" }
        ]
    },
    {
        category: "Readability & Plain Language",
        items: [
            { name: "readability words hyperlinks.pdf", note: "Vocabulary guidance" },
            { name: "readability scoring hyperlinks.pdf", note: "Score interpretation" },
            { name: "readability formula hyperlinks.pdf", note: "Formula definitions" },
            { name: "readability articles hyperlinks.pdf", note: "Supporting research" },
            { name: "readable_words_lists.txt", note: "Word-level dataset" },
            { name: "readable_scoring_content.txt", note: "Scoring content" },
            { name: "readable_formulas.md", note: "Formula documentation" },
            { name: "Readable Articles_intro.md", note: "Readability article summaries" }
        ]
    },
    {
        category: "Multimedia / SMIL",
        items: [
            { name: "SMIL hyperlinks.pdf", note: "SMIL reference mapping" },
            { name: "all_smil_content.txt", note: "SMIL corpus" }
        ]
    },
    {
        category: "Internal System Logic",
        items: [
            { name: "Prompt Taxonomy.pdf", note: "Internal logic structure" }
        ]
    }
];

function DataSources() {
    const navigate = useNavigate();

    return (
        <section className="data-sources-page fade-in-up" aria-labelledby="ds-title" style={{ animationDelay: '0.2s', position: 'relative' }}>
            {!isEmbedPath() && <TopRightAuth />}

            <button
                onClick={() => navigate("/")}
                className="chat-back-button fade-in-up"
                title="Back to Home"
                aria-label="Back to home"
            >
                <ArrowLeft size={16} aria-hidden="true" focusable="false" />
                <span>Back</span>
            </button>
            <div className="data-sources-header">
                <div className="welcome-logo-container">
                    <img src={optibotLogoNoText} alt="Optibot accessibility tool delivering instant answers for WCAG, ADA, and Section 508 compliance" className="welcome-logo" />
                </div>
                <h1 id="ds-title" className="data-sources-title">Knowledge <span className="brand-primary-text">Sources</span></h1>
                <p className="subtitle">Documents and standards that power my responses.</p>
            </div>
            <div className="data-sources-grid">
                {DATA_SOURCES.map((group, idx) => (
                    <div key={idx} className="source-category-card">
                        <h2 className="source-category-label">{group.category}</h2>
                        <div className="source-list">
                            {group.items.map((item, iIdx) => (
                                <div key={iIdx} className="source-item">
                                    <span className="source-name">{item.name}</span>
                                    <span className="source-note">{item.note}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default DataSources;
